/* TextMenuSection.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./TextMenuSection.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { TEXT_COLLAPSED_MENU } from '@atlaskit/editor-common/toolbar';
import { ToolbarDropdownItemSection } from '@atlaskit/editor-toolbar';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  menu: "_1rjcv77o _18zru2gc"
};
export var TextMenuSection = function TextMenuSection(_ref) {
  var children = _ref.children,
    parents = _ref.parents;
  var hasSeparator = parents.some(function (parent) {
    return parent.key === TEXT_COLLAPSED_MENU.key;
  });
  return /*#__PURE__*/React.createElement(ToolbarDropdownItemSection, {
    hasSeparator: hasSeparator
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.menu
  }, children));
};